import {
  Box,
  Typography,
  makeStyles,
  styled,
  withStyles
} from '@material-ui/core';

export const AISumContainer = styled(Box)(() => ({
  borderRadius: 12,
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  gridGap: 12,
  minHeight: 350,
  height: '100%',
  overflow: 'auto',
  color: '#333',
  border: '1px solid #EEF0F2',
  margin: '8px 24px 24px',
  padding: 16
}));

export const Text = withStyles({
  root: {
    fontSize: 20,
    fontWeight: 700
  }
})(Typography);

export const useCustomTabelStyles = makeStyles(({ spacing }) => ({
  table: {
    borderCollapse: 'collapse',
    backgroundColor: '#fff',
    borderRadius: 8,
    overflow: 'hidden',
    width: '100%',
    '& td, th': {
      textAlign: 'left',
      padding: spacing(2),
      height: 48,
      borderRadius: 8,
      color: '#333'
    },
    '& tr:nth-child(odd)': {
      backgroundColor: '#F8F9FA'
    }
  }
}));
